import { render, staticRenderFns } from "./MCQStats.vue?vue&type=template&id=30e731a3&scoped=true"
import script from "./MCQStats.vue?vue&type=script&setup=true&lang=js"
export * from "./MCQStats.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MCQStats.vue?vue&type=style&index=0&id=30e731a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e731a3",
  null
  
)

export default component.exports